import { LoadingSpinnerIconTwoTone, OutlinedUserIcon } from '@room-match/shared-ui-components';
import React, { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { COLORS } from 'shared/constants/COLORS';
import { ROUTES } from 'shared/constants/ROUTES';

import { profileService } from 'shared/services/profileService';
import { CardContainer, CardHeader, EmptyContainer } from '../Dashboard.styles';
import {
  Container,
  NameContainer,
  ProfileItemContainer,
  ProfileItemPic,
  ProfileItemPicContainer,
} from './Profile.styles';
import { Tooltip } from '@material-ui/core';
import { CustomTypography } from 'shared/elements/CustomTypography';
const { WARNING_TEXT } = COLORS;

const { getProfilesGraphQL } = profileService();
const Profile = () => {
  const { data, isLoading } = getProfilesGraphQL('');
  const history = useHistory();
  const [isOpenNamePopOver, setIsOpenNamePopOver] = useState<HTMLElement | null>(null);
  const [currAgencyName, setCurrAgencyName] = useState<string>('Non Represented');
  const profiles = useMemo(() => data?.data?.profiles, [data]);

  const handleNamePopOverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>, agencyName: string) => {
    setIsOpenNamePopOver(event.currentTarget);
    setCurrAgencyName(agencyName);
  };

  const handleNamePopOverClose = () => {
    setIsOpenNamePopOver(null);
  };

  const handleClick = (id: string) => {
    history.push(`${ROUTES.TALENT.PROFILES}/${id}/images_video_audio`);
  };

  return isLoading ? (
    <>
      <LoadingSpinnerIconTwoTone />
    </>
  ) : (
    <CardContainer>
      <CardHeader>
        <div>
          <OutlinedUserIcon className="profile-icon" />
          <span style={{ fontSize: 18 }}>Representatives</span>
        </div>
      </CardHeader>
      <Container>
        {profiles ? (
          profiles.map(({ id, primary_medium_attachment, agency, casting_private, casting_company, division }, n) => (
            <ProfileItemContainer onClick={() => handleClick(id)} key={n}>
              <ProfileItemPicContainer>
                <ProfileItemPic
                  src={
                    primary_medium_attachment?.modified_attachment ||
                    primary_medium_attachment?.attachment ||
                    '/assets/user.png'
                  }
                />
              </ProfileItemPicContainer>
              <Tooltip title={currAgencyName}>
                <NameContainer
                  aria-owns={isOpenNamePopOver ? `profile-name-${id}-${n}` : undefined}
                  aria-haspopup="true"
                  onMouseEnter={(e: any) =>
                    handleNamePopOverOpen(e, agency?.full_name || agency?.name || 'Non Represented')
                  }
                  onMouseLeave={handleNamePopOverClose}
                >
                  {agency?.full_name || agency?.name ? (
                    <React.Fragment>
                      <CustomTypography color="primary" fontSize={14}>
                        {agency?.full_name || agency?.name}
                      </CustomTypography>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {casting_private ? (
                        <CustomTypography style={{ color: WARNING_TEXT }} fontSize={14}>
                          {casting_company.name}
                        </CustomTypography>
                      ) : (
                        <CustomTypography color="primary" fontSize={14}>
                          Non Represented
                        </CustomTypography>
                      )}
                    </React.Fragment>
                  )}
                </NameContainer>
              </Tooltip>

              {/* <StyledPopover
                id={`profile-name-${id}-${n}`}
                open={Boolean(isOpenNamePopOver)}
                anchorEl={isOpenNamePopOver}
                style={{ pointerEvents: 'none' }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                onClose={handleNamePopOverClose}
              >
                <NamePopOverContainer>{currAgencyName}</NamePopOverContainer>
              </StyledPopover> */}
              {division && division ? (
                <NameContainer style={{ marginTop: -5 }}>
                  <CustomTypography fontSize={12}>{division.name}</CustomTypography>
                </NameContainer>
              ) : (
                <React.Fragment />
              )}
            </ProfileItemContainer>
          ))
        ) : (
          <EmptyContainer>No data available</EmptyContainer>
        )}
      </Container>
    </CardContainer>
  );
};

export default Profile;
